import React, { FunctionComponent } from 'react';

export const Presentation: FunctionComponent = () => {
  return (
    <div className="rtf-top-links">
      <div className="company-terms">
        <div className="terms-body">
          <h2 className="title">利用規約（掲載企業向け｜成功報酬プラン）</h2>

          <p className="terms-statement">株式会社READY TO FASHION（以下「当社」といいます。）は、当社がSNSサービス「READY TO FASHION」（以下「サービス」と総称します。）内において提供する成功報酬プラン（以下「本プラン」と総称します。）に関し、以下のとおり利用規約（以下「本利用規約」といいます。）を定めています。本利用規約は、掲載企業として「RTFカンパニーアカウント」（以下「本アカウント」といいます。）を登録し本プランを利用されるすべての企業、各種団体、個人その他の利用者（法人、個人事業主を含みます。以下「掲載企業」といいます。）に適用されるため、本アカウントをご登録される前によくご覧ください。</p>

          <p className="terms-article-title">第1条（本プランのご利用と本利用規約などへの同意）</p>

          <p>掲載企業は、本利用規約および当社が本サービスの提供にあたり定める<a href="/companies/terms">各種規約</a>（以下「本利用規約など」と総称します。）に同意することにより、本利用規約などの定めに従って本サービス・本プランを利用することができます。本利用規約などにご同意いただけない場合、本サービス・本プランをご利用いただくことができません。掲載企業は、実際に本アカウントを登録することにより、本利用規約などの内容にご同意いただいたものとみなされます。</p>

          <p className="terms-article-title"> 第2条（登録料および登録料相当額のディスカウント）</p>
          <ul>
              <li>
                1. 掲載企業は、本規約に同意のうえプラン登録を行った時点で、登録料が発生します。登録料は10万円（税別）とします。<br /><br />
                <p>掲載企業は、請求書に記載された支払期日（登録日の翌月末日）までに当社の指定する口座に対する振込送金方法にて当該請求書に記載された本サービスの登録料を支払うものとします。なお、振込手数料は掲載企業の負担とします。掲載企業は、本条に基づく登録料について、これに係る消費税相当額を加算して支払うものとします。掲載企業が登録料の支払を遅滞した場合、掲載企業は年14.6%の割合による遅延損害金を当社に支払うものとします。</p>
              </li>

              <li>
                2. 掲載企業は、初回の1名の採用時の報酬料金から、本登録料分を控除することができるものとします。<br /><br />
                <p>例：新卒採用の報酬料金：50万円 - 10万円 = 40万円(税別)</p>
              </li>

              <li>3. ディスカウントの対象期間は登録から1年間とする。当該期間経過後は、登録料の返還は行わないものとします。</li>
          </ul>


          <p className="terms-article-title">第3条（報酬料金の発生）</p>
          <ul>
            <li>
              1. 掲載企業は、本サービスの本プランを利用して求職者を採用し、入社に至った場合、成功報酬料金が発生するものとし、報酬料金の発生日は、次の各号に定めるとおりとします。<br /><br />
              <ul>
                <li>(1) 新卒採用（大学院卒/大卒/専門卒/高卒）の場合、内定後、採用決定者が入社意思を書面にて示した日。</li>
                <li>(2) 中途採用・アルバイト等採用の場合、掲載企業への入社日。</li>
                <li>(3) 業務委託・副業の場合、業務開始日。</li>
              </ul>
            </li>
            <li>2. 採用決定者が本サービスにてエントリーした日付より前の日付にて、既に当該採用決定者が掲載企業へのエントリーを1年以内に行っていた場合、または他の紹介事業者により掲載企業に1年以内に紹介されていた場合には、当該採用決定者の内定が本プランへの報酬料金支払の対象外とします。</li>
            <li>3. 掲載企業が、本サービスの本プランにて求職者との間で、最後に採用に関するメッセージ又は面談など接触行為（オンライン及びオフラインを問わず、またメッセージの場合には返信の有無にかかわらず、あらゆる方法によるものを含みます。以下同じ。）があった日から1年以内に採用し入社又は業務開始に至った場合は、本サービスを利用して求職者を採用し入社又は業務開始に至ったものとみなし、本条に基づく成功報酬が発生するものとします。</li>
          </ul>


          <p className="terms-article-title">第4条（報酬料金について）</p>
          <ul>
            <li>
              1. 掲載企業は、本サービスの本プランを利用して求職者を採用し、入社に至った場合、成功報酬として、下記の(1)～(2)のとおり報酬料金を支払うものとします。<br /><br />
              <ul>
                <li>(1) 新卒採用（大学院卒/大卒/専門卒/高卒）の場合、「50万円(税別)/1名あたり」</li>
                <li>(2) 中途採用、アルバイト・業務委託、副業採用の場合、1名あたり「理論年収の15%(税別)」もしくは30万円(税別)のいずれか大きい方</li><br />
                <li><p>※インターン採用の場合、選考を目的とした金銭の発生が伴わない場合には、費用を発生しないものとする。しかしその後、新卒採用として入社する場合には(1)の報酬料金が発生するものとする。</p></li>
              </ul>
            </li>
            <li>
              2. 理論年収は下記の(1)～(3)の計算式によって算出されるものとします。<br /><br />
              <ul>
                <li>(1) 「理論年収」 = （月給固定額 × 12ヶ月）+ 賞与</li>
                <li>(2) 「月給固定額」 = 基本給 + 諸手当（固定残業代等）</li>
                <li>(3) 「賞与」 = 賞与算定基準額 × 前年度の支給実績月数</li><br />
                <li><p>※契約期間が12ヶ月未満の場合でも、12ヶ月分として理論年収を計算いたします。</p></li>
              </ul>
            </li>
            <li>
              3. 新卒の区分については、下記の(1)(2)に該当する場合に定義します。<br /><br />
              <ul>
                <li>(1) 新卒（大学院卒/大卒/専門卒/高卒）は、採用決定時に在学中である場合。</li>
                <li>(2) 1週の所定労働時間もしくは1ヶ月の所定労働日数が同じ会社で同様の業務に従事している正社員の4分の3以上の勤務の場合。</li>
              </ul>
            </li>
          </ul>


          <p className="terms-article-title">第5条（報酬料金の支払い）</p>
          <p>掲載企業は、第4条1項の(1)においては、採用決定者が入社意思を書面にて示した日の属する月の、第4条1項の(2)については、採用決定者の掲載企業への入社日の属する月の翌月末日（末日が金融機関休業日の場合は翌営業日）までに、報酬料金およびその消費税等相当額を当社の指定する銀行口座に一括して振込んで支払うものとします。</p>


          <p className="terms-article-title">第6条（報酬料金の返還）</p>
          <ul>
              <li>1. 新卒採用（大学院卒/大卒/専門卒/高卒）の場合、採用決定者が、入社日までに自己都合により内定辞退した場合、または第6条4項に定める内定の取消があった場合、当社は、当該内定承諾者につき受領した報酬料金の100%を、内定辞退または内定取消があった日の属する月の翌月末日までに、掲載企業の指定する銀行口座へ返還するものとします。この際の振込手数料は当社が負担するものとする。</li>

              <li>
                2. 中途採用、アルバイト、業務委託、副業の場合、採用決定者が、本人の自己都合（本人の死亡その他の傷病を理由とするものも含む。）で退職・契約解除した場合、懲戒解雇を理由に退職した場合、または天災事変等掲載企業の責めに帰すことができない事由により退職した場合において、掲載企業が本人退職後30日以内に通知したときは、当社は掲載企業より受領した成功報酬に以下の(1)〜(3)の割合を乗じた金額を当該採用決定者の退職日の属する月の翌月末までに掲載企業に返金するものとします。なお、返金の振込手数料は当社の負担とします。<br /><br />
                <ul>
                  <li>(1) 退職日が入社日から1ヶ月以内である場合 50%</li>
                  <li>(2) 退職日が入社日から1ヶ月を超えて2ヶ月以内である場合 30%</li>
                  <li>(3) 退職日が入社日から2ヶ月を超えて3ヶ月以内である場合 10%</li>
                </ul>
              </li>

              <li>
                3. 内定となった採用決定者が以下の各号に該当する場合、掲載企業は内定を取消すことができるものとする。<br /><br />
                <ul>
                  <li>(1) 内定者が卒業を予定している年度に卒業できなかったとき。</li>
                  <li>(2) 採用にあたり提出した書類に虚偽があったとき。</li>
                  <li>(3) 病気や事故により就労に耐えられないとき。</li>
                  <li>(4) 刑事事件で逮捕歴があることが判明したとき。</li>
                  <li>(5) その他、音信不通になる、公序良俗に反する行為を行うなど、内定を取消されてもやむを得ない事由があったとき。</li>
                </ul>
              </li>
          </ul>


          <p className="terms-article-title">第7条（掲載企業の遵守事項）</p>
          <ul>
            <li>1. 掲載企業は、当社からの要請を受けた場合、求職者の選考過程に関して、その進行に応じて報告しなければならないものとします。</li>
            <li>2. 掲載企業は、求職者の採用又は不採用（受託者については業務開始又は不開始）の決定をした場合には、求職者に対して、その結果を報告するものとします。</li>
            <li>3. 掲載企業は、求職者から入社承諾書が届き次第当社に対して、労働条件通知書及び求職者の押印済みの内定時承諾書等その他労働条件及び契約が成立したことを証する書面の各写しを提出するものとします。</li>
            <li>4. 掲載企業は、当社又は求職者から取得した求職者の個人情報を、個人情報保護法その他の法律に従って厳格に管理するものとします。</li>
            <li>5. 掲載企業は、求職者が、掲載企業との間の採用の状況、掲載企業等のやりとり（メールや本サービスにおけるメッセージの内容を含むがこれに限定されない）を当社に開示することを認め、これについて、当社及び求職者に異議を述べないものとします。</li>
            <li>6. 掲載企業は、本サービス上でメッセージ又は面談など接触（オンライン及びオフラインを問わず、またメッセージの場合には返信の有無にかかわらず、あらゆる方法によるものを含みます。以下、本項において同じ。）をした求職者を別の企業の採用のためにスカウト又は紹介等を行ってはならないものとします。掲載企業が本項に違反したことにより、当該別の企業が求職者を採用し入社又は業務開始に至った場合には、第3条の規定における報酬料金の発生とみなし、同項に基づき掲載企業は当社に対して成功報酬を支払うものとします。</li>
          </ul>


          <p className="terms-article-title">第8条（禁止行為）</p>
          <ul>
              <li>
                1. 掲載企業は、本サービスの利用にあたり、以下の各号のいずれかに該当する行為をしてはなりません。<br /><br />
                <ul>
                  <li>(1) 本サービスで知り得た求職者に対し、本サービスを介さずに直接接触する行為。</li>
                  <li>(2) 本サービスで知り得た求職者から、本サービスを介さずに応募するよう促す行為。</li>
                  <li>(3) 当社又は求職者から提供された個人情報を当社及び当該求職者の承諾なく第三者に開示する行為。</li>
                </ul>
              </li>

              <li>2. 掲載企業は、本サービスを通じて知り得た求職者を採用し、入社または業務を依頼したにもかかわらず、故意、過失に関わらず当社に対して入社日の前日までに報告を行わなかった場合、または虚偽の報告を行うなどして正しい成果報酬金額の徴収を妨げる行為を行った場合、本来支払われていたと推定される金額とは別に違約金として雇用形態に関わらず100万円/1名あたりを当社に支払うものとします。</li>
          </ul>


          <p className="terms-article-title">第9条（本利用規約などの変更について）</p>
          <ul>
            <li>1. 当社は、当社が必要と判断した場合には、掲載企業に対する事前の通知なくして、本利用規約などの内容を変更することができるものとします。ただし、当該変更が掲載企業に大きな影響を与えると当社が合理的に判断する場合には、あらかじめ合理的な事前告知期間を設けるものとします。この場合において、掲載企業が本利用規約などの変更に同意しないときは、当社が別途定める場合を除いて、当該事前告知期間内に当社所定の方法により当社へ通知するものとします。</li>
            <li>2. 変更後の本利用規約などは、当社が別途定める場合を除いて、本サービスの提供にあたり表示された時点から効力を生じるものとします。</li>
            <li>3. 掲載企業が、本利用規約などの変更の効力が生じた後に本サービスを利用する場合には、変更後の本利用規約などのすべての記載事項に同意したものとみなされます。</li>
          </ul>

          <div className='terms-last'>
            <p>(附則)</p>
            <div>
              <p className='terms-padding-none'>2020年11月25日 制定・適用</p>
              <p>2026年4月22日 制定・適用</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};
